/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-04-07 09:31:30
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-02 12:54:40
 */
import { asyncRoutes, constantRoutes } from '@/router'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * 整个路由的权限 用路由数组判断  不是路由code a_a
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && (route.meta.actionName || route.meta.actionNameArray)) {
    return roles?.some(role => {
      let bool =
        (route.meta.actionName && route.meta.actionName === role['menuCode']) ||
        (route.meta.actionNameArray && route.meta.actionNameArray.includes(role['menuCode']))
      return bool
    }) // stauts为1则展示，2不展示
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const permission = {
  state: {
    routes: [],
    addRoutes: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    }
  },
  actions: {
    emptyRoutes({ commit }) {
      commit('SET_ROUTES', [])
    },
    generateRoutes({ commit }, roles) {
      return new Promise(resolve => {
        const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)
      })
    }
  }
}

export default permission
